export const AboutMe =
{
  name: 'yabu',
  profileImage: '/images/IMG_8969.jpg',
  age: '19',
  profile: 'こんにちは、yabuです。エンジニアになるためにプログラミングを学んでいます。作品を通じて、私のスキルや成長を見ていただければと思います。',
};

export const learningSkills = [
    { name: 'React', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg', color: '#61DAFB' },
    { name: 'Next.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg', color: '#000000' },
    { name: 'MySQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg', color: '#4479A1' },
    { name: 'Tailwind css', icon: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.d52e9897.svg', color: '#06B6D4' },
    { name: 'C++', icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/ISO_C%2B%2B_Logo.svg/288px-ISO_C%2B%2B_Logo.svg.png', color: '#3776AB' },
    { name: 'Prisma', icon: 'https://w7.pngwing.com/pngs/130/82/png-transparent-prisma-hd-logo-thumbnail.png', color: '#3776AB' },
    { name: 'Supabase', icon: 'https://logo.svgcdn.com/d/supabase-original-8x.png', color: '#3776AB' },
  ];
